import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from '@material-ui/core/TablePagination';
import { AuthContext } from "../Auth";
import { getUserTasksHistory }  from "../firebase/firebaseService";

const useStyles = makeStyles({
  table: {
    minWidth: 300,
  },
});

export default function HistoryTable() {
  const classes = useStyles();
  const [words, setWords] = useState(null);
  const { currentUser } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getUserTasksHistory(currentUser)
      .then(userTasks => setWords(userTasks))
      .finally(() => setIsLoading(false));
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  if (!isLoading) {
    return (
      <>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Word</TableCell>
              <TableCell align="right" >Type</TableCell>
              <TableCell align="right">Example sentence</TableCell>
              <TableCell align="right">Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {words? words.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
              <TableRow key={row.uid} data-test="item">
                <TableCell scope="row" data-test="name">
                  {row.name}
                </TableCell>
                <TableCell align="right" data-test="type">{row.type}</TableCell>
                <TableCell align="right" data-test="sentence">{row.sentence}</TableCell>
                <TableCell align="right" data-test="date">{row.date}</TableCell>
              </TableRow>
            )): null}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 15, 25, 50]}
        component="div"
        count={words?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
    );
  }

  if (isLoading) {
    return <CircularProgress color="secondary" />;
  }
}
